<mat-card class="form-card" [formGroup]="formPack">
  <div class="space-v-xl">
    <button
      *ngIf="hasTargetDomainForBinaries && searchResultComponent!.dataSource!.data!.length > 0"
      class="right"
      (click)="publishPackEventEmit()"
      mat-raised-button
      color="accent"
    >
      {{ 'REFDATA.PACKS.PUBLISH' | translate }}
    </button>
  </div>

  <mat-card-content class="form-card-content">
    <mat-accordion>
      <mat-expansion-panel
        #archivesPanel
        *ngIf="displayArchives"
        class="mat-elevation-z0"
        (opened)="(true)"
        [expanded]="true"
        [disabled]="false"
      >
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h2 class="archives space-t-m">{{ 'REFDATA.PACKS.TABS.ARCHIVES' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <hr />
          <div class="space-v-xl">
            <app-pack-archives-list
              #archivesListComponent
              [pack]="pack"
              [shouldReload$]="shouldReload$"
              [applianceGroupsRefData]="applianceGroupsRefData$ | async"
            >
            </app-pack-archives-list>
          </div>
          <div class="space-v-xl">
            <app-pack-generate-archive-form
              #archivesFormComponent
              [pack]="pack"
              [applianceGroupsRefData]="applianceGroupsRefData$ | async"
              (newArchiveHasBeenGenerated$)="onBinaryGenerated()"
              (displayArchivesPanel$)="onDisplayArchivesPanel($event)"
            ></app-pack-generate-archive-form>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel
        #binariesPanel
        *ngIf="displayBinaries"
        class="mat-elevation-z0"
        (opened)="(true)"
        [expanded]="true"
        [disabled]="false"
      >
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h2 class="binaries space-t-m">{{ 'REFDATA.PACKS.TABS.BINARIES' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <hr />
          <div class="pb-20">
            <app-pack-binaries-list
              #binariesListComponent
              [pack]="pack"
              [shouldReload$]="shouldReload$"
              [applianceGroupsRefData]="applianceGroupsRefData$ | async"
              (binaryModified$)="refreshPack()"
            ></app-pack-binaries-list>
          </div>
          <div class="pb-20">
            <app-pack-generate-binary-form
              [pack]="pack"
              [applianceGroupsRefData]="applianceGroupsRefData$ | async"
              (newBinaryHasBeenGenerated$)="onBinaryGenerated()"
              (displayBinariesPanel$)="onDisplayBinariesPanel($event)"
            ></app-pack-generate-binary-form>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel
        id="recipesPanels"
        #recipesPanel
        class="mat-elevation-z0"
        [expanded]="true"
        (opened)="(true)"
        (closed)="(false)"
        [disabled]="true"
      >
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h2 class="archives space-t-m">{{ 'REFDATA.PACKS.TABS.RECIPES' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <hr />
          <div class="pb-20 space-t-xxl">
            <app-recipes-search-result
              #searchResultComponent
              [brands]="brands"
              [domains]="domains | async"
              [markets]="markets"
              [languages]="languages"
              [_sort]="sort"
              [status]="status"
              [searchResult]="searchResult | async"
              [isSelectionDisabled]="false"
              [getSelectedRecipe]="selectedAllRecipe | async"
              (selectAllRecipe)="selectAllRecipe()"
              (searchChange)="handleSearch($event)"
              (associateRecipesChanges)="refreshRecipesList()"
              (closePopup)="onCloseDialog()"
              [options]="[]"
              [associateRecipesMode]="true"
              [pack]="pack"
            >
            </app-recipes-search-result>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
